export const isComponentOfType = (component, typeName) => (
    component?.type === typeName ?? false
);
